import { Model } from '@vuex-orm/core'

export default class Class extends Model {
  static entity = 'classes'

  static fields() {
    return {
      id: this.string(''),
      teacher_id: this.string(''),
      name: this.string(''),
      year_levels: this.attr(null),
      lessons: this.attr(null),
      messages: this.attr(null),
      students_number: this.attr(''),
      created_at: this.attr(''),
      class_invitation_deleted: this.attr(null)
    }
  }
}
